export const HERO_IMAGE_URL = "/hero-mountains.jpg";

/** KM monogram: forest tile + cream mark — favicon + admin header brand */
export const SITE_LOGO_MARK_URL = "/km-favicon-forest-cream.svg";

/** Wax seal monogram (filename uses | — encode in URL for reliable loading) */
export const SAVE_THE_DATE_SEAL_URL = "/K%7CM.png";

export const COUPLE_NAMES = "Kim & Matt";

/** For running text, e.g. “Kim and Matt”. */
export const COUPLE_NAMES_IN_PROSE = COUPLE_NAMES.replace(" & ", " and ");

export const WEDDING_DATE_LOCATION = "8 May 2027 · Blue Mountains, NSW";

export const HOME_HERO_EYEBROW = "We're getting married";

export const SAVE_THE_DATE_CONTENT = {
  couple: COUPLE_NAMES,
  title: "Save the Date",
  description: `You're invited to celebrate the wedding of ${COUPLE_NAMES_IN_PROSE}. Leave your details and we will send formal invites, schedule updates, and travel information as plans are finalized.`,
  submitLabel: "Keep me updated",
};

/** Matches VENUE_NAME/address in backend src/emails/sampleInvitationEmail.js — keep in sync. */
export const VENUE_NAME = "The Hydro Majestic Blue Mountains";
export const VENUE_ADDRESS = "88 Great Western Highway, Medlow Bath NSW 2780";
export const VENUE_GOOGLE_MAPS_URL =
  "https://www.google.com/maps/place/The+Hydro+Majestic+Hotel+Blue+Mountains/@-33.6757917,150.2808556,16z/data=!4m2!3m1!1s0x0:0xb9377f3b53ee4927";
export const RECEPTION_ROOM_NAME = "Grand Majestic Ballroom";

export const CEREMONY_DATE_TEXT = "Saturday, 8 May 2027";
export const CEREMONY_TIME_TEXT = "Ceremony at 4:00 PM";
export const CEREMONY_LOCATION_TEXT = "Blue Mountains, NSW, Australia";
export const DRESS_CODE_TEXT = "Formal attire";

export const VENUE_INTRO_TEXT =
  "Where the celebration begins. The backdrop to our favourite day.";

/**
 * Draft running order. First dance time is still undecided — update once set.
 */
export const SCHEDULE_EVENTS = [
  {
    time: "3:30 PM",
    title: "Guests Arrive",
    description: "Arrive any time from 3:30pm and find your seat",
    groom: "Free booze starts here. Don't be late.",
  },
  {
    time: "4:00 PM",
    title: "Ceremony",
    description: "Exchange of vows",
    groom: "I will absolutely cry. Betting pool is open.",
  },
  {
    time: "5:00 PM",
    title: "Canapés",
    description: "Drinks & canapés",
    groom: "This is where I pretend to remember everyone's name.",
  },
  {
    time: "6:00 PM",
    title: "Reception Begins",
    description: "Dinner and speeches throughout the evening",
    groom: "I've been told the food is amazing. I'll be too nervous to eat.",
  },
  {
    time: "TBD",
    title: "First Dance",
    description: "Matt & Kim take the floor",
    groom: "I've had three dance lessons. Prepare to be underwhelmed.",
  },
  {
    time: "8:00 PM",
    title: "Dance Floor Opens",
    description: "Party time!",
    groom: "DJ has been specifically instructed: no Macarena. Okay fine, maybe one Macarena.",
  },
  {
    time: "10:30 PM",
    title: "Last Song",
    description: "Final song of the night",
    groom: "If you're still standing, you win. Prize TBD.",
  },
  {
    time: "11:00 PM",
    title: "Send Off",
    description: "Final farewell",
    groom: "This is genuinely goodbye. Please don't linger, the venue has a curfew and so do I.",
  },
];

export const FAQS = [
  {
    question: "Can I bring a plus one?",
    answer:
      "Your invitation will specify if you have a plus one. If you're unsure, just ask us.",
    groom: "Please don't bring your ex. I'm not naming names, but you know who you are.",
  },
  {
    question: "Are kids invited?",
    answer:
      "We love your little ones, but this will be an adults-only celebration. We hope you understand!",
    groom: "Look, I can barely keep myself under control at weddings. Let's not add toddlers to the mix.",
  },
  {
    question: "What should I wear?",
    answer:
      "Formal attire, please. Think suits and cocktail or full-length dresses. The ceremony is outdoors so bring a layer for the evening.",
    groom: "Anything fancier than what I normally wear to Bunnings. Which, to be fair, is a low bar.",
  },
  {
    question: "How do I get there?",
    answer:
      "We recommend driving — the venue is about 2 hours from Sydney. We'll share detailed directions and parking info closer to the date.",
    groom: "If your GPS says 'turn left into the ravine,' don't. Trust me, I've tested this route.",
  },
  {
    question: "Is there a discount code for accommodation?",
    answer:
      "Yes — reach out to us directly and we'll send you the room code.",
    groom: "DM me. I promise to respond faster than I do to literally any other message.",
  },
];
